import { ESM2to1PredictionItem, ESM2to1FilterOptions } from '@/types/esm2to1';
import { apiClient } from './client';

export const getESM2to1FilterOptions = (): ESM2to1FilterOptions => {
  return {
    stock_name: '',
    watchlists: []
  };
};

/**
 * Fetch ESM 2-to-1 predictions based on filter criteria
 */
export const getESM2to1Predictions = async (filters: Record<string, unknown> = {}): Promise<ESM2to1PredictionItem[]> => {
  try {
    const response = await apiClient.get('/market/esm-2-to-1-prediction', {
      params: filters
    });
    
    // Type assertion for response structure
    const responseData = response.data as { data: ESM2to1PredictionItem[] };
    
    // Ensure we have a valid response structure
    if (!responseData.data) {
      console.warn('Unexpected API response structure:', responseData);
      return [];
    }
    
    return responseData.data || [];
  } catch (error) {
    console.error('Error fetching ESM 2-to-1 predictions:', error);
    throw error;
  }
};
